import actionTypes from './actionTypes';
import { fetch } from '../api';

export function toggleActionSuccess(follow, currentUserId, item) {
  return {
    type: actionTypes.FOLLOW_TOGGLE_SUCCESS,
    isAsynchronous: true,
    follow: {
      ...follow,
      currentUserId,
      isFollowing: item.isFollowing,
    },
  };
}

export function toggleFollow(type: String, id: Number) {
  const follow = { type, id };

  return async function(dispatch, getState) {
    dispatch({ type: actionTypes.FOLLOW_TOGGLE, follow });

    try {
      const { data = { [type]: {} }, context } = getState();
      const item = data[type][id];
      const currentUserId = context.userId;
      const body = type === 'groups'
          ? { groupId: id, userId: currentUserId }
          : { id };

      await fetch(`follow/${type.slice(0, -1)}`, {
        method: item.isFollowing ? 'POST' : 'DELETE',
        body: JSON.stringify(body),
      });

      dispatch(toggleActionSuccess(follow, currentUserId, item));
    } catch (error) {
      dispatch({ type: actionTypes.FOLLOW_TOGGLE_FAILURE, follow, error, isAsynchronous: true });
    }
  };
}



// WEBPACK FOOTER //
// ./~/virgo/src/actions/followActionsCreator.js